export default ({ instance }) => {
	return {
		consultarReclamacoes(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/consultar-notificacoes",
				data: filtro,
			});
		},

		consultarAndamentosProcon(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/consultar-andamentos",
				data: filtro,
			});
		},

		consultarAnexosNotificacao(id) {
			return instance({
				method: "get",
				url: "reclamacoes/consultar-anexos/" + id,
			});
		},

		consultarReclamacaoDetalhada(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/consultar-notificacao/",
				data: filtro
			});
		},

		consultarListaProcon() {
			return instance({
				method: "get",
				url: "reclamacoes/lista-procon",
			});
		},

		consultarListaStatus() {
			return instance({
				method: "get",
				url: "reclamacoes/lista-status",
			});
		},

		consultarLoginClientes() {
			return instance({
				method: "get",
				url: "integracoes/consultar-logins",
			});
		},

		consultarClientes() {
			return instance({
				method: "get",
				url: "integracoes/consultar-clientes",
			});
		},

		consultarDocumentos() {
			return instance({
				method: "get",
				url: "reclamacoes/consultar-documentos",
			});
		},

		consultarAndamentoPorIdReclamacao(idReclamacao) {
			return instance({
				method: "get",
				url:
					"reclamacoes/consultar-andamentos-reclamacao/" +
					idReclamacao,
			});
		},

		consultarCredenciais() {
			return instance({
				method: "get",
				url: "integracoes/consultar-credenciais",
			});
		},

		consultarPaineis(idCredencial) {
			return instance({
				method: "get",
				url: "integracoes/consultar-paineis/" + idCredencial,
			});
		},

		consultarPaineisCliente(idCliente) {
			return instance({
				method: "get",
				url: "integracoes/consultar-paineis-cliente/" + idCliente,
			});
		},

		ativarDesativarPainel(credencial) {
			return instance({
				method: "post",
				url: "integracoes/ativar-desativar-painel",
				data: credencial,
			});
		},

		adicionarCredencial(credencial) {
			return instance({
				method: "post",
				url: "integracoes/adicionar-credencial",
				data: credencial,
			});
		},
		adicionarNovoSistema(credencial) {
			return instance({
				method: "post",
				url: "integracoes/adicionar-novo-sistema",
				data: credencial,
			});
		},
		editarCredencial(credencial) {
			return instance({
				method: "post",
				url: "integracoes/editar-credencial",
				data: credencial,
			});
		},

		consultarEvolucaoMensal(filtro) {
			return instance({
				method: "post",
				url: "painel/evolucao-mensal",
				data: filtro,
			});
		},

		consultarAssuntosMaisReclamados(filtro) {
			return instance({
				method: "post",
				url: "painel/assuntos-por-procon",
				data: filtro,
			});
		},

		consultarSituacaoAtual(filtro) {
			return instance({
				method: "post",
				url: "painel/situacao-reclamacoes",
				data: filtro,
			});
		},

		consultarDistribuicaoGeografica(filtro) {
			return instance({
				method: "post",
				url: "painel/distribuicao-reclamacoes",
				data: filtro,
			});
		},

		consultartermoAceito() {
			return instance({
				method: "get",
				url: "integracoes/consultar-termo-aceito",
			});
		},

		aceitarTermosTeste(termoAceito) {
			return instance({
				method: "post",
				url: "integracoes/aceitar-termos",
				data: termoAceito,
			});
		},

		alterarPainelLogin(painelLogin) {
			return instance({
				method: "post",
				url: "integracoes/alterar-painel-login",
				data: painelLogin,
			});
		},
		consultarRegistroExecucoes(idCredencial) {
			return instance({
				method: "get",
				url: "integracoes/consultar-registro-execucoes/" + idCredencial,
			});
		},
		consultarTagsProcon(produto) {
			return instance({
				method: "get",
				url: "reclamacoes/tags/" + produto,
			});
		},
		cadastrarTagProcon(tag) {
			return instance({
				method: "post",
				url: "reclamacoes/cadastrar-tag",
				data: tag,
			});
		},
		cadastrarTagNotificacaoProcon(tag) {
			return instance({
				method: "post",
				url: "reclamacoes/cadastrar-tag-notificacao",
				data: tag,
			});
		},
		excluirTagProcon(tag) {
			return instance({
				method: "post",
				url: "reclamacoes/remover-tag",
				data: tag,
			});
		},
		proconExportarNotificacoesExcel(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "reclamacoes/exportar-notificacoes-excel",
				data: filtro,
			});
		},
		proconExportarNotificacoesSelecionadasExcel(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "reclamacoes/exportar-notificacoes-selecionadas-excel",
				data: filtro,
			});
		},
		proconExportarNotificacoesJson(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/exportar-notificacoes-json",
				data: filtro,
			});
		},
		proconExportarNotificacoesXml(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "reclamacoes/exportar-notificacoes-xml",
				data: filtro,
			});
		},
		proconExportarNotificacoesDocx(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "reclamacoes/exportar-notificacoes-docx",
				data: filtro,
			});
		},
		proconExportarNotificacoesSelecionadasDocx(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "reclamacoes/exportar-notificacoes-selecionadas-docx",
				data: filtro,
			});
		},
		proconExportarNotificacoesSelecionadasJson(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/exportar-notificacoes-selecionadas-json",
				data: filtro,
			});
		},
		proconExportarNotificacoesSelecionadasXml(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "reclamacoes/exportar-notificacoes-selecionadas-xml",
				data: filtro,
			});
		},
		proconSalvarRascunhoFiltro(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/salvar-rascunho-filtro",
				data: filtro,
			});
		},
		proconRecuperarRascunhoFiltro() {
			return instance({
				method: "get",
				url: "reclamacoes/recuperar-rascunho-filtro",
			});
		},
		proconRemoverRascunhoFiltro(nome) {
			return instance({
				method: "post",
				url: "reclamacoes/remover-rascunho-filtro/" + nome,
			});
		},
		buscarPerfilRisco(grupoOperacional){
			return instance({
				method: "get",
				url: "reclamacoes/buscar-perfil-risco/" + grupoOperacional,
			});
		},
		buscarNaturezaPerfilRisco() {
			return instance({
				method: "get",
				url: "reclamacoes/buscar-natureza-perfil-risco",
			});
		},
		salvarRegraPerfilRisco(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/salvar-regra-perfil-risco",
				data: filtro
			});
		},
		editarRegraPerfilRisco(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/editar-regra-perfil-risco",
				data: filtro
			});
		},
		removerRegraPerfilRisco(filtro) {
			return instance({
				method: "post",
				url: "reclamacoes/remover-regra-perfil-risco",
				data: filtro
			});
		},
		proconDownloadAnexo(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "reclamacoes/download-anexo",
				data: filtro,
			});
		},
		consultarSistemas() {
			return instance({
				method: "get",
				url: "integracoes/consultar-sistemas",
			});
		},
		editarSistemaProcon(sistema) {
			return instance({
				method: "post",
				url: "integracoes/editar-sistema",
				data: sistema,
			});
		},
		ativarDesativarCredencial(credencial) {
			return instance({
				method: "post",
				url: "integracoes/ativar-desativar-credencial",
				data: credencial,
			});
		},
		relatorioPorMesAnoProcon(filtro) {
			return instance({
				method: "post",
				url: "painel/mes-ano",
				data: filtro,
			});
		},
		proconConsultarAtividadeRecente(filtro) {
			return instance({
				method: "post",
				url: "painel/atividade-recente",
				data: filtro,
			});
		},
		relatorioPorMesAnoHomeProcon(filtro) {
			return instance({
				method: "post",
				url: "painel/mes-ano-home",
				data: filtro,
			});
		},
	};
};
